import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import APIError from 'types/api_error';

import { useAPI } from 'hooks/api/useAPI';

export function useUnlockPipeline(
  options: UseMutationOptions<void, APIError, { pipeline_id: string }> = {}
) {
  const { applicationID, client } = useAPI();

  return useMutation(
    ({ pipeline_id }) =>
      client.post(
        `/internal/apps/${applicationID}/pipelines/${pipeline_id}/unlock`
      ),
    options
  );
}
